interface RegexTypes extends Record<string, RegExp> {
  [key: string]: RegExp;
}

export const regexTypes: RegexTypes = {
  checkMultipleEmails:
    /^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*@((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+)(?:[A-Z0-9-]{2,63}(?<!-))$/i,
};
